import styled from "styled-components";
import { COLORS, responsive } from "../../../styles/constants.style";

export const BillingConfigurationMilestoneTypeWrapper = styled.div`
  .billing-configuration-top {
    margin: 24px 0px;
    ${responsive.MOBILE`
      margin: 16px 0;
    `}
  }

  .MuiGrid2-root {
    padding-right: 0px;
  }

  .billing-configuration-middle {
    margin: 24px 0px;
  }

  .billing-configuration-add-button {
    margin-top: 24px;
    justify-content: flex-end;
    display: flex;
  }

  .billing-configuration-total-amount-percentage-container {
    display: flex;
    align-items: center;
    column-gap: 4px;
  }

  .billing-configuration-table {
    margin-top: 20px;
  }

  .config-header {
    margin-bottom: 8px;
  }

  .dashed-line {
    margin: 24px 0px;
    border: 1px dashed ${COLORS.primary_light_blue4};
    ${responsive.MOBILE`
      margin: 16px 0;
    `}
  }
  .bottom-button-clear {
    ${responsive.MOBILE`
        width: 100%;
        margin-left: 0px;
        margin-top:16px;
      `}
  }
  .bottom-button-continue {
    margin-left: 16px;
    ${responsive.MOBILE`
        width: 100%;
        margin-left: 0px;
        margin-top:16px;
      `}
  }
`;
